/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.teams.rpc.AppFatTeams
 */

/**
 *  Filters controlling which users are returned in team-membership responses.
 */

export const getByHubRpc = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'getByHub',
  auth: 'app',
  fingerprint: 'FriHTTv_poQcAhsZOQx25FRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByHubWithHierarchyRpc = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'getByHubWithHierarchy',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAcAhsZOQx25FRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAccessibleByPortalUserRpc = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'getAccessibleByPortalUser',
  auth: 'app',
  fingerprint: 'rsk8uk0ewuscAhsZOQx25FRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAccessibleByPortalUserUniqueRpc = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'getAccessibleByPortalUserUnique',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAcAhsZOQx25FRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByIdRpc = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'getById',
  auth: 'app',
  fingerprint: 'IUUjZsLaqtxtq2s0XW_iO1RizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByIdsRpc = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'getByIds',
  auth: 'app',
  fingerprint: 'z4sSjSgxTbQcAhsZOQx25FRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createRpc = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'OdqFcXM-rEhKzw4pbD2TAFRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateFatTeamsRpc = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'updateFatTeams',
  auth: 'app',
  fingerprint: '8HiwTIPJhAZtq2s0XW_iO1RizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateParentTeamsRpc = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'updateParentTeams',
  auth: 'app',
  fingerprint: '3NQKdC-Luj8cAhsZOQx25FRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteTeamsRpc = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'deleteTeams',
  auth: 'app',
  fingerprint: 'jnkPIBCqIWkcAhsZOQx25FRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setPortalUserTeamsStateRpc = {
  serviceName: 'com.hubspot.teams.rpc.AppFatTeams',
  rpcName: 'setPortalUserTeamsState',
  auth: 'app',
  fingerprint: '9YYYNcTqqtRsX8rNP4cSOVRizqN7wosy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};